import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import { Pagination, Navigation} from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {

    initializeSlider()
    initializeImages()


    if (window.Fancybox) {
        Fancybox.bind('[data-fancybox="gallery"]', {
            Hash: false,
        });
    }
});




function initializeSlider() {
    document.querySelectorAll('.swiper-vehicle-card').forEach((swiperEl) => {
        let cardCarSwiper = new Swiper(swiperEl, {
            modules: [Pagination, Navigation],
            loop: true,
            navigation: {
                prevEl:  swiperEl.parentElement.querySelector('.js-car-slider-prev'),
                nextEl:  swiperEl.parentElement.querySelector('.js-car-slider-next'),
            },
            pagination: {
                el: swiperEl.parentElement.querySelector('.swiper-pagination'),
                clickable: true,
                dynamicBullets: true,
            },
        });
    });
}

function initializeImages() {
    document.querySelectorAll('.swiper-vehicle-card').forEach((swiperEl) => {
        const images = swiperEl.querySelectorAll('.swiper-slide img');

        images.forEach((image) => {
                image.classList.add('loaded');
        });
    });
}
